import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { DelegationLibraryComponent } from './delegate/delegation-library/delegation-library.component';
import { DocumentTemplateManagementComponent } from './document-template-management/document-template-management/document-template-management.component'
import { DocumentDetailsComponent } from './document/document-details/document-details.component';
import { DocumentLibraryComponent } from './document/document-library/document-library.component';
import { EqmsScopeManagementComponent } from './eqms-scope/eqms-scope-management/eqms-scope-management.component';
import { UserSelectComponent } from './user-select/user-select.component';
import { CourseDetailsComponent } from './course/course-details/course-details.component';
import { SessionAttendeeQuizResultComponent } from './course/session/session-attendee-quiz-result/session-attendee-quiz-result.component';
import { MyHardCopyComponent } from './my-hard-copy/my-hard-copy.component';
import { MyDocReviewComponent } from './my-doc-review/my-doc-review.component';
import { MyDocApprovalsComponent } from './my-doc-approvals/my-doc-approvals.component';
import { MyQaReviewsComponent } from './my-qa-reviews/my-qa-reviews.component';
import { CourseLibraryComponent } from './course/course-library/course-library.component';
import { UserHomeComponent } from './my-space/user-home/user-home.component';
import { UserProfileComponent } from './my-space/user-profile/user-profile.component';
import { AssignmentGroupComponent } from './system-admin/assignment-group/assignment-group.component';
import { MyFavoritesComponent } from './my-favorites/my-favorites.component';
import { MyAssignAdminComponent } from './my-assign-admin/my-assign-admin.component';
import { TrainingItemGroupLibraryComponent } from './training-item/training-item-group-library/training-item-group-library.component';
import { MyChangeRequestsComponent } from './my-change-requests/my-change-requests.component';
import { MyDocFormattingsComponent } from './my-doc-formattings/my-doc-formattings.component';
import { CurriculumLibraryComponent } from './curriculum/curriculum-library/curriculum-library.component';
import { MyDocCollabsComponent } from './my-doc-collabs/my-doc-collabs.component';
import { ChangeControlDetailsComponent } from './change-control/change-control-details/change-control-details.component';
import { ConfigurationService } from './shared/services/configuration.service';
import { ChangeControlLibraryComponent } from './change-control/change-control-library/components/change-control-library/change-control-library.component';
import { MyClientSignaturesComponent } from './my-client-signatures/my-client-signatures.component';
import { TrainingStatusComponent } from './reporting/training-status/training-status.component';
import { ActionItemLibraryComponent } from './action-item-catalogue/action-item-library/action-item-library.component';
import { MyQuarantinedDocumentsComponent } from './quarantined-documents/components/my-quarantined-documents/my-quarantined-documents.component';
import { RecordKPRChatComponent } from './record-kpr/components/record-kpr-chat/record-kpr-chat.component';
import { DocumentLoaderComponent } from './document/document-loader/document-loader.component';

const routes: Route[] = [
  {
    path: "eqms.document",
    component: DocumentLibraryComponent,
  },
  {
    path: '',
    redirectTo: 'my-space/eqms.home', 
    pathMatch: "full",
  },
  {
    path: 'eqms.documentDetails/:id',
    component: DocumentDetailsComponent
  },
  {
    path: 'eqms.eqmsScopeManagement',
    component: EqmsScopeManagementComponent
  },
  {
    path: 'eqms.documentTemplatesManagement',
    component: DocumentTemplateManagementComponent
  },
  {
    path: 'eqms.delegate',
    component: DelegationLibraryComponent
  },
  { path: 'eqms.myhard-copy', loadChildren: () => import('./my-hard-copy/my-hard-copy.module').then(m => m.MyHardCopyModule) },
  { path: 'eqms.my-doc-review', loadChildren: () => import('./my-doc-review/my-doc-review.module').then(m => m.MyDocReviewModule) },
  { path: 'eqms.my-doc-approvals', loadChildren: () => import('./my-doc-approvals/my-doc-approvals.module').then(m => m.MyDocApprovalsModule) },
  { path: 'eqms.my-qa-reviews', loadChildren: () => import('./my-qa-reviews/my-qa-review.module').then(m => m.MyQaReviewsModule) },
  {
    path:'eqms.userSelection',
    component: UserSelectComponent
  },
  { path: 'eqms.course', loadChildren:()=> import('./course/course.module').then(m=>m.CourseModule)},
  { path: 'eqms.assignment-group', loadChildren: () => import('./system-admin/assignment-group/assignment-group.module').then(m => m.AssignmentGroupModule) },
  {
    path:'training/eqms.courses/:courseNumber',
    component:CourseDetailsComponent
  },
  {
    path:'training/eqms.quizAnswers/:puid',
    component:SessionAttendeeQuizResultComponent
  },
  {path: 'eqms.documentViewer/:id', component: DocumentLoaderComponent},
  { path: 'eqms.my-favorites', loadChildren: () => import('./my-favorites/my-favorites.module').then(m => m.MyFavoritesModule) },
  { path: 'eqms.my-assign-admin', loadChildren: () => import('./my-assign-admin/my-assign-admin.module').then(m=> m.MyAssignAdminModule) },
  { path: 'my-space', loadChildren: () => import('./my-space/my-space-module').then(m=> m.MySpaceModule) },

  { path: 'eqms.training-item', loadChildren: () => import('./training-item/training-item.module').then(m => m.TrainingItemModule) },
  { path: 'eqms.my-change-requests', loadChildren: () => import('./my-change-requests/my-change-requests.module').then(m => m.MyChangeRequestsModule) },
  { path: 'eqms.my-doc-formattings', loadChildren: () => import('./my-doc-formattings/my-doc-formattings.module').then(m => m.MyDocFormattingsModule) },
  { path: 'eqms.curriculum', loadChildren: () => import('./curriculum/curriculum.module').then(m => m.CurriculumModule) },
  { path: 'eqms.curriculum/curriculumLinkout', loadChildren: () => import('./curriculum/curriculum.module').then(m => m.CurriculumModule) },
  { path: 'eqms.training-item/trainingItemGroupLinkout', loadChildren:()=> import('./training-item/training-item.module').then(m=> m.TrainingItemModule)},
  { path: 'eqms.my-doc-collabs', loadChildren: () => import('./my-doc-collabs/my-doc-collabs.module').then(m => m.MyDocCollabsModule) },
  { path: 'eqms.change-control', loadChildren: () => import('./change-control/change-control.module').then(m => m.ChangeControlModule) },
  { path: 'eqms.changeControlDetails/:id',children: [{ path: '', component: ChangeControlDetailsComponent }]},
  { path: 'eqms.action-item-register', loadChildren: () => import('./action-item-catalogue/action-item-catalogue.module').then(m => m.ActionItemCatalogueModule) },
  { path: 'eqms.my-client-signatures', loadChildren: () => import('./my-client-signatures/my-client-signatures.module').then(m => m.MyClientSignaturesModule) },
  { path: 'eqms.my-quarantined-documents', loadChildren: () => import('./quarantined-documents/quarantined-documents.module').then(m => m.QuarantinedDocumentsModule) },
  { path: 'eqms.training-status', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule)},
  { path: 'eqms.record-kpr', loadChildren: () => import('./record-kpr/record-kpr.module').then(m => m.RecordKPRModule) },
];

const mainRoutes: Route[] = [
  {
    path: "eqms.document",
    children: [{path: '', component: DocumentLibraryComponent}]
  },
  {
    path: '',
    redirectTo: 'my-space/eqms.home', 
    pathMatch: "full",
  },
  {
    path: 'eqms.documentViewer/:id',
    children: [{path: '', component: DocumentLoaderComponent}]
  },
  {
    path: 'eqms.documentDetails/:id',
    children: [{path: '', component: DocumentDetailsComponent}]
  },
  {
    path: 'eqms.eqmsScopeManagement',
    children: [{path: '', component: EqmsScopeManagementComponent}]
  },
  {
    path: 'eqms.documentTemplatesManagement',
    children: [{path: '', component: DocumentTemplateManagementComponent}]
  },
  {
    path: 'eqms.delegate',
    children: [{path: '', component: DelegationLibraryComponent}]
  },
  { path: 'eqms.myhard-copy', children:[{ path: '', component: MyHardCopyComponent }] },
  { path: 'eqms.my-doc-review', children:[{ path: '', component: MyDocReviewComponent }] },
  { path: 'eqms.my-doc-approvals', children:[{ path: '', component: MyDocApprovalsComponent }] },
  { path: 'eqms.my-qa-reviews', children:[{ path: '', component: MyQaReviewsComponent }] },
  {
    path:'eqms.userSelection',
    children: [{path: '', component: UserSelectComponent}]
  },
  { path: 'eqms.course', children:[{ path: '', component: CourseLibraryComponent }]},
  { path: 'eqms.assignment-group', children:[{path: '', component: AssignmentGroupComponent}]},
  {
    path:'training/eqms.courses/:courseNumber',
    children: [{path: '', component: CourseDetailsComponent}]
  },
  {
    path:'training/eqms.quizAnswers/:puid',
    children: [{path: '', component: SessionAttendeeQuizResultComponent}]
  },
  { path: 'eqms.my-favorites', children:[{ path: '', component: MyFavoritesComponent }]},
  { path: 'eqms.my-assign-admin', children:[{path: '', component: MyAssignAdminComponent}]},
  { path: 'my-space', children:[
    { path: 'eqms.home', children:[{ path: '', component: UserHomeComponent }] },
    { path: 'eqms.user-profile', children: [{ path: '', component: UserProfileComponent }] }
  ] },

  { path: 'eqms.training-item', children:[{ path: '', component: TrainingItemGroupLibraryComponent }]},
  { path: 'eqms.training-item/trainingItemGroupLinkout', children:[{ path: '', component: TrainingItemGroupLibraryComponent }]},
  { path: 'eqms.my-change-requests', children: [{ path: '', component: MyChangeRequestsComponent }]},
  { path: 'eqms.my-doc-formattings', children: [{ path: '', component: MyDocFormattingsComponent }]},
  { path: 'eqms.curriculum', children: [{ path: '', component: CurriculumLibraryComponent }]},
  { path: 'eqms.curriculum/curriculumLinkout', children: [{ path: '', component: CurriculumLibraryComponent }]},
  { path: 'eqms.my-doc-collabs', children: [{ path: '', component: MyDocCollabsComponent }]},
  { path: 'eqms.change-control', children: [{ path: '', component: ChangeControlLibraryComponent }]},
  // {
  //   path: "eqms.change-control",
  //   component: ChangeControlLibraryComponent,
  // },
  { path: 'eqms.changeControlDetails/:id', component: ChangeControlDetailsComponent,  },
  { path: 'eqms.action-item-register', children : [{ path: '', component: ActionItemLibraryComponent }]},
  { path: 'eqms.my-client-signatures', children:[{ path: '', component: MyClientSignaturesComponent }]},
  { path: 'eqms.my-quarantined-documents', children:[{ path: '', component: MyQuarantinedDocumentsComponent }]},
  {
    path: 'eqms.training-status', children: [{path: '', component: TrainingStatusComponent}]
  },
  { path: 'eqms.record-kpr', children: [{ path: '', component: RecordKPRChatComponent }]}
];

let loadRoute = ConfigurationService.isLimsHosted ? mainRoutes : routes;

@NgModule({
  imports: [RouterModule.forRoot(loadRoute)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
